<template>
  <div class="margin-bottom-xs grid-container">
    <div class="grid-x grid-margin-x margin-bottom-s">
      <div class="cell small-12 medium-12">
        <div
          style="height: 300px"
          class="skeleton-loader"
        ></div>
      </div>
    </div>
    <div class="grid-x grid-margin-x margin-bottom-s">
      <div class="cell small-12 medium-12">
        <div
          style="height: 150px"
          class="skeleton-loader"
        ></div>
      </div>
    </div>
    <div class="grid-x grid-margin-x margin-bottom-s">
      <div class="cell small-4 large-4">
        <div
          style="height: 200px"
          class="skeleton-loader"
        ></div>
      </div>
      <div class="cell small-4 large-4">
        <div
          style="height: 200px"
          class="skeleton-loader"
        ></div>
      </div>
      <div class="cell small-4 large-4">
        <div
          style="height: 200px"
          class="skeleton-loader"
        ></div>
      </div>
    </div>
    <div class="grid-x grid-margin-x margin-bottom-s">
      <div class="cell small-12 medium-12">
        <div
          style="height: 600px"
          class="skeleton-loader"
        ></div>
      </div>
    </div>
  </div>
</template>
